// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../assets/Mb_banner.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.banner-container {
  position: relative;
  width: 100%;
}

.bannerImage {
  width: 100%;
  display: block;
}

.text-container {
  position: absolute;
  bottom: 0;
  left: 0;
  top: 15%;
  padding-left: 20px; 
  color: #fff;
  width: 50%; 
}

.heading {
  padding-bottom: 10px;
  font-size: 24px;
  font-weight: bold;
  text-transform: uppercase;
  /* margin-bottom: 20px; */
}

.subheading {
  /* margin: 0; */
  font-size: 16px; 
  margin-bottom: 50px;
}

.findrace-button {
  display: flex;
  justify-content: flex-start; 
  margin: 0; 
}

.findrace-button button {
  margin-top: 0;
  display: flex;
  width: 236px;
  height: 54px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  color: #fff;
  background: #000;
  font-family: "Thicker";
  font-size: clamp(16px, 4vw, 24px) !important;
  font-style: normal;
  font-weight: 500;
  line-height: 126.6%;
  text-transform: uppercase;
  border: none;
  /* margin-top: 0; */
}

.findrace-button button:hover {
  background-color: #1D1D1D;
}

.banner-heading{
  color: #FFF;
font-family: Thicker;
font-size: 54px;
font-style: normal;
font-weight: 600;
line-height: 105%; /* 56.7px */
}

.banner-subheading{
  color: #FFF;
font-family: lightThicker;
font-size: 20px;
font-style: normal;
font-weight: 400;
line-height: 125%; /* 25px */
}



.banner-container-mobile{
  display: none;
}


@media screen and (max-width: 900px) {

.text-container {
  top: 15%;
}

.findrace-button button {
  width: 200px;
  height: 45px;
}

}


@media screen and (max-width: 800px) {

  .text-container {
    top: 8%;
  }
  
  .findrace-button button {
    margin-top: -10px;
    width: 150px !important;
    height: 35px !important;
    font-size: 10px !important;
  }
  
  }
  



@media screen and (max-width: 650px) {
  .banner-container{
    display: none;
  }
  .banner-container-mobile {
    display: flex;
    align-items: center; 
    width: 100%;
  }
  
  .text-container-mobile {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    color: white; 
    padding: 20px; 
    width: 100%; 
    box-sizing: border-box; 
    text-align: center;
  }
  
  .banner-heading-mobile {
    font-size: 24px; 
    margin: 0 0 10px 0; 
  }
  
  .banner-subheading-mobile {
    font-size: 16px; 
    margin: 0 0 20px 0;
  }
  
  .findrace-button-mobile {
    margin-top: 10px; 
  }
  
  .findrace-button-mobile button {
    background: #000;
    color: white; 
    border: none; 
    padding: 10px 20px;   font-size: 16px; 
    cursor: pointer; 
  }
  
  .banner-image-mobile {
    width: 100%; 
    height: auto; 
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/findRaceFooter/findrace.css"],"names":[],"mappings":";AACA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,4CAA4C;EAC5C,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb,oBAAoB;AACpB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,WAAW;AAC9B;;AAEA;EACE,WAAW;AACb,yBAAyB;AACzB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,SAAS;AAC5B;;;;AAIA;EACE,aAAa;AACf;;;AAGA;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;;;AAGA;;EAEE;IACE,OAAO;EACT;;EAEA;IACE,iBAAiB;IACjB,uBAAuB;IACvB,uBAAuB;IACvB,0BAA0B;EAC5B;;EAEA;;;;;AAKF;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,yDAAsD;IACtD,YAAY;IACZ,aAAa;IACb,WAAW;IACX,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,YAAY;IACZ,YAAY;IACZ,kBAAkB,IAAI,eAAe;IACrC,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["\n.banner-container {\n  position: relative;\n  width: 100%;\n}\n\n.bannerImage {\n  width: 100%;\n  display: block;\n}\n\n.text-container {\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  top: 15%;\n  padding-left: 20px; \n  color: #fff;\n  width: 50%; \n}\n\n.heading {\n  padding-bottom: 10px;\n  font-size: 24px;\n  font-weight: bold;\n  text-transform: uppercase;\n  /* margin-bottom: 20px; */\n}\n\n.subheading {\n  /* margin: 0; */\n  font-size: 16px; \n  margin-bottom: 50px;\n}\n\n.findrace-button {\n  display: flex;\n  justify-content: flex-start; \n  margin: 0; \n}\n\n.findrace-button button {\n  margin-top: 0;\n  display: flex;\n  width: 236px;\n  height: 54px;\n  justify-content: center;\n  align-items: center;\n  flex-shrink: 0;\n  color: #fff;\n  background: #000;\n  font-family: \"Thicker\";\n  font-size: clamp(16px, 4vw, 24px) !important;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 126.6%;\n  text-transform: uppercase;\n  border: none;\n  /* margin-top: 0; */\n}\n\n.findrace-button button:hover {\n  background-color: #1D1D1D;\n}\n\n.banner-heading{\n  color: #FFF;\nfont-family: Thicker;\nfont-size: 54px;\nfont-style: normal;\nfont-weight: 600;\nline-height: 105%; /* 56.7px */\n}\n\n.banner-subheading{\n  color: #FFF;\nfont-family: lightThicker;\nfont-size: 20px;\nfont-style: normal;\nfont-weight: 400;\nline-height: 125%; /* 25px */\n}\n\n\n\n.banner-container-mobile{\n  display: none;\n}\n\n\n@media screen and (max-width: 900px) {\n\n.text-container {\n  top: 15%;\n}\n\n.findrace-button button {\n  width: 200px;\n  height: 45px;\n}\n\n}\n\n\n@media screen and (max-width: 800px) {\n\n  .text-container {\n    top: 8%;\n  }\n  \n  .findrace-button button {\n    margin-top: -10px;\n    width: 150px !important;\n    height: 35px !important;\n    font-size: 10px !important;\n  }\n  \n  }\n  \n\n\n\n@media screen and (max-width: 650px) {\n  .banner-container{\n    display: none;\n  }\n  .banner-container-mobile {\n    display: flex;\n    align-items: center; \n    width: 100%;\n  }\n  \n  .text-container-mobile {\n    background-image: url(\"../../../assets/Mb_banner.jpg\");\n    color: white; \n    padding: 20px; \n    width: 100%; \n    box-sizing: border-box; \n    text-align: center;\n  }\n  \n  .banner-heading-mobile {\n    font-size: 24px; \n    margin: 0 0 10px 0; \n  }\n  \n  .banner-subheading-mobile {\n    font-size: 16px; \n    margin: 0 0 20px 0;\n  }\n  \n  .findrace-button-mobile {\n    margin-top: 10px; \n  }\n  \n  .findrace-button-mobile button {\n    background: #000;\n    color: white; \n    border: none; \n    padding: 10px 20px;   font-size: 16px; \n    cursor: pointer; \n  }\n  \n  .banner-image-mobile {\n    width: 100%; \n    height: auto; \n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
